import "./base.js";

// This will be used to populate the providers collection
// FIXME: We probably need to make this a regular backbone model, not a relational one, or we won't be able to instantiate Physician and Location models with the same id
//        BackboneRelational keeps a store of instantiated models per class, so we can new up a Provider with the same id as one that has already been loaded

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Models ??= {};

AppointmentBooking.SlotSuggester.Models.Provider = class Provider extends AppointmentBooking.SlotSuggester.Models.Base {
  defaults() {
    return {
      id: null,
      type: null,
      name: null,
      url: null,
      credentialsForLabel: [],
      rating: null,
      ratingInfoUrl: null,
      imageUrl: null,
    };
  }
};
AppointmentBooking.SlotSuggester.Models.Provider.prototype.idAttribute = "gid";
